<template>
    <div class="vue-delivery-date-picker">
        <p class="font-weight-bold input-label">{{ datepickerLabel }}</p>

        <p class="small">{{ datePickerPlaceholder }}</p>

        <datepicker
            v-model="deliveryDate"
            :disabled-dates="disabledDates"
            :monday-first="true"
            format="dd-MM-yyyy"
            :placeholder="datePickerPlaceholder"
            @input="handleInput"
            ref="datePickerTest"
        ></datepicker>

        <p class="delivery-info">{{ deliveryDateInfo }}</p>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    name: "DeliveryDatepicker",

    components: {
        Datepicker
    },

    props: {
        disabledDeliveryDates: {
            type: Array,
            default: null
        }
    },

    data() {
        return {
            datePickerPlaceholder: window.Drupal.t('Select a date'),
            datepickerLabel: window.Drupal.t('Desired delivery day'),
            deliveryDateInfo: window.Drupal.t('If you place your order before 11:00 AM, it can be delivered the next working day.'),
            deliveryDate: null,
        }
    },

    mounted() {
        this.setInitialDeliveryDay();
    },

    computed: {
        disabledDates() {
            let disabledDatesOptions = {
                to: this.disabledTo,
                days: [6, 0]
            }

            if (this.hasDisabledDeliveryDates) {
                _.merge(disabledDatesOptions, {
                    dates: this.disabledDeliveryDateRange,
                });
            }

            return disabledDatesOptions;
        },

        disabledTo() {
            let today = new Date(Date.now());
            let hour = today.getHours();

            if (hour >= 11) {
                return new Date(today.setDate(today.getDate() + (today.getDay() === 5 ? 3 : 1)));
            }

            return today;
        },

        disabledDeliveryDateRange() {
            if (!this.hasDisabledDeliveryDates) {
                return false;
            }

            return _.map(this.disabledDeliveryDates, (item) => {
                return new Date(item);
            })
        },

        hasDisabledDeliveryDates() {
            let filledDates = _.filter(this.disabledDeliveryDates, (item) => {
                return item !== '';
            });

            return !_.isEmpty(filledDates);
        }
    },

    methods: {
        handleInput(value) {
            let year = value.getFullYear();
            let month = value.getMonth() + 1;
            let day = value.getDate();

            let fullDate = day + '-' + month + '-' + year;

            this.$emit('input', fullDate);
        },

        setInitialDeliveryDay() {
            let firstEnabledDate = this.getNextAvailableDeliveryDay()

            if (!lodash.isNil(firstEnabledDate)) {
                this.deliveryDate = new Date(firstEnabledDate.timestamp);
                this.handleInput(this.deliveryDate);
                return;
            }

            let now = new Date();
            let nextMonth;
            if (now.getMonth() === 11) {
                nextMonth = new Date(now.getFullYear() + 1, 0, 1).getTime();
            } else {
                nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1).getTime();
            }

            this.$children[0].pageTimestamp = nextMonth;

            setTimeout(() => {
                let firstEnabledDate = this.getNextAvailableDeliveryDay();

                if (!lodash.isNil(firstEnabledDate)) {
                    this.deliveryDate = new Date(firstEnabledDate.timestamp);
                    this.handleInput(this.deliveryDate);
                }
            }, 150);
        },

        getNextAvailableDeliveryDay() {
            return _.head(_.filter(this.$children[0].$children[1].days, (item) =>{
                return ! item.isDisabled;
            }));
        }
    }
}
</script>